import { Box, createTheme, ThemeProvider } from "@mui/material";
import Main from "./components/layout/Main/Main";
import Header from "./components/layout/Header/Header";
import { BrowserRouter } from "react-router-dom";
import NoticeDaialog from "./components/feedback/NoticeDaialog/NoticeDaialog";
import NoticeAlert from "./components/feedback/NoticeAlert/NoticeAlert";
import Footer from "./components/layout/Footer/Footer";
import AppRoutes from "./pages/AppRoutes";
import ErrorBoundary from "./pages/ErrorBoundary/ErrorBoundary";

const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      light: '#00b0f0',
      main: '#00b0f0',
      dark: '#00b0f0',
      contrastText: '#fff'
    },
    secondary: {
      light: '#ff0000',
      main: '#ff0000',
      dark: '#ff0000',
      contrastText: '#fff'
    },
    background: {
      default: '#fff',
      paper: '#fff'
    },
  },
  typography: {
    fontFamily: [
      '"BIZ UDPGothic"',
      'sans-serif'
    ].join(',')
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Box id='app' sx={(theme) => ({
        minWidth: 400,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
      })}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Header />
          <Main>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </Main>
          <Footer />
        </BrowserRouter>
        <NoticeDaialog />
        <NoticeAlert />
      </Box>
    </ThemeProvider >
  )
}
